var STRIPE_PUBLISHABLE_KEY = document.currentScript && document.currentScript.dataset.stripeKey;

$(function () {

  // --- DOM REFERENCES ---

  const emailInput = document.querySelector('#inp_email');
  const infoButtonIcon = document.querySelector('.info-button');
  const btnPassword = document.querySelector('#btn_password');
  const googlePayInput = document.querySelector('#inp_google_pay_available');


  // --- FUNCTIONS ---

  let formSubmitted = false;

  function submitForm(event, arg) {
    event.preventDefault();

    if (formSubmitted) {
      return;
    }

    var form = document.getElementById("form");

    if (arg && arg.forceCheck) {
      document.getElementById('checkbox-terms_and_conditions').checked = true;
    }

    // Disabling the submit button to prevent multiple submissions
    formSubmitted = true;
    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
    }

    form.submit();
  }

  function togglePassword(event) {
    let toggleBtn = event.srcElement;
    let name = toggleBtn.id.replace('btn_', '');
    let input = document.getElementById('inp_' + name);
    input.classList.add('input-focus');
    if (input.type === 'password') {
      input.type = 'text';
      toggleBtn.innerHTML = 'Hide';
    } else {
      input.type = 'password';
      toggleBtn.innerHTML = 'Show';
    }
  }

  function focusOnInput() {
    let toggleBtn = event.srcElement;
    let name = toggleBtn.id.replace('btn_', '');
    let input = document.getElementById('inp_' + name);
    input.classList.remove('input-focus');
    input.focus();
  }

  function handleFocus(event) {
    let inputElement = event.srcElement;
    if (inputElement.classList.contains('invalid-input')) {
      const inpErrorId = 'inp_error_' + inputElement.id.substr(4);
      let errorElement = document.getElementById(inpErrorId);
      errorElement.remove();
      inputElement.classList.remove('invalid-input');
    }
  }

  function displayModal(modalId) {
    let modal = document.getElementById(modalId);
    modal.style.display = 'block';
  }

  function closeModal(event, modalId) {
    let modal = document.getElementById(modalId);
    modal.style.display = 'none';
  }


  // --- EVENT BINDINGS ---

  // Detect Google Pay availability and record it in the hidden field for the POST
  if (STRIPE_PUBLISHABLE_KEY && window.Stripe && googlePayInput) {
    const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
    const paymentRequest = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Piknik',
        amount: 1199,
      },
    });

    paymentRequest.canMakePayment().then(function (result) {
      googlePayInput.value = !!(result && result.googlePay);
      console.log('Google Pay available: ' + googlePayInput.value);
    }).catch(function () {
      googlePayInput.value = false;
      console.log('Google Pay available: ' + googlePayInput.value);
    });
  }

  // Order summary toggle
  $('#orderMainContainer').click(function () {
    $('#orderSummaryPromoSection').toggleClass('expanded');
    $(this).toggleClass('expanded');
  });

  // Form submission
  document.querySelector('#form').addEventListener('submit', submitForm);

  // Inputs: clear validation errors on focus
  document.querySelectorAll('.form-input').forEach(function (el) {
    el.addEventListener('focus', handleFocus);
  });

  // Password visibility toggle
  btnPassword.addEventListener('mousedown', togglePassword);
  btnPassword.addEventListener('mouseup', focusOnInput);

  // Info modal
  if (infoButtonIcon) {
    infoButtonIcon.addEventListener('click', function () {
      displayModal('info-modal');
    });
  }

  // Modal close (close button and action button)
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.js-modal-close');
    if (btn) {
      closeModal(event, btn.dataset.modalId);
    }
  });

  // 'Yes, I agree' button in not-agreed-modal submits form with forceCheck
  var agreeButton = document.querySelector('#not-agreed-modal .modal-button');
  if (agreeButton) {
    agreeButton.addEventListener('click', function (event) {
      submitForm(event, { forceCheck: true });
    });
  }

  // Re-enable the submit button when the page is restored from bfcache (e.g. via back button)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      formSubmitted = false;
      var submitBtn = document.querySelector('#form button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = false;
      }
    }
  });

});